import { Grid, Typography } from '@mui/material';
import useStyles from '../../style/js-style/components/AdminSettingsStyle';
import React, { useContext } from 'react';
import i18next from 'i18next';
import MenuAppBar from '../MenuAppBar';
import { Context } from '../../states/Store';
import EAColorIcon from '../common/EAColorIcon';
import AdminSettingTabs from './AdminSettingTabs';
import EAPagination from '../common/datatable/EAPagination';
import { useQuery } from '../../config/Config';
import { ADMIN_SECTION } from '../../services/common/Constants';

function AdminSettings() {
  const [state] = useContext(Context);
  let tabQueryParam = useQuery().get('tab');
  const { classes } = useStyles();
  return (
    <>
      <Grid
        container
        spacing={2}
        className={classes.root}
        style={{
          background: state.personalization.isCustomTemplate
            ? 'linear-gradient(180deg, ' +
              state.personalization.colorPrimary +
              'FF 0%, ' +
              state.personalization.colorPrimary +
              'CC 50%, rgba(256,256,256) 90%)'
            : 'linear-gradient(180deg, #003A22CC 0%, #003A22CC 50%, rgba(256,256,256) 90%)',
        }}
      >
        <div
          className={classes.headerWrapper}
          style={{
            backgroundImage: state.personalization.isCustomTemplate
              ? "url('/img/background/bg-aprovall_white.png')"
              : "url('/img/background/bg-aprovall.png')",
          }}
        >
          {/* AppBar Custom */}
          <div className={classes.appBar}>
            <MenuAppBar variant="admin" />
          </div>

          {/* Header */}
          <Grid container className={classes.headerContent}>
            <Grid item xs={2} className={classes.adminIconWrapper}>
              <EAColorIcon
                icon={'parameters_darkGreen'}
                svgStyle={{ position: 'relative', top: '3px' }}
                width={20}
              />
            </Grid>
            <Grid item xs={10}>
              <Typography variant={'h2'} className={classes.title}>
                {i18next.t('adminSettings.configurationMessage')}
              </Typography>
            </Grid>
          </Grid>
        </div>

        <AdminSettingTabs />
      </Grid>
      {!(
        tabQueryParam === ADMIN_SECTION.DEMANDES ||
        tabQueryParam === ADMIN_SECTION.PERSONALIZATION ||
        tabQueryParam === ADMIN_SECTION.CONSUMPTION
      ) && <EAPagination />}
    </>
  );
}

export default AdminSettings;
